var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67462 10.2043L1.67462 10.5889C1.45023 10.5889 1.23467 10.5058 1.07572 10.3557C0.759392 10.0562 0.755662 9.57737 1.06681 9.27313L4.83988 5.58877L1.06686 1.90446C0.755619 1.60064 0.759351 1.12161 1.07597 0.821898C1.40837 0.507783 1.95557 0.511894 2.28215 0.830694L6.60548 5.05226C6.9128 5.35283 6.9128 5.82471 6.60525 6.12549L2.28232 10.3467C2.1232 10.5022 1.90362 10.5889 1.67462 10.5889L1.67462 10.2043Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoForward);
export default __webpack_public_path__ + "static/media/ico_forward.fd2c120a23096663c9ddf8d64080c43b.svg";
export { ForwardRef as ReactComponent };